import { render } from "./AppHeaderEditorCmp.vue?vue&type=template&id=21878d1e"
import script from "./AppHeaderEditorCmp.vue?vue&type=script&lang=js"
export * from "./AppHeaderEditorCmp.vue?vue&type=script&lang=js"

import "./AppHeaderEditorCmp.vue?vue&type=style&index=0&id=21878d1e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__